import { Component } from "react";

import { ModalLink } from "@app/shared/Modals";

interface ArchiveProjectLinkProps {
  archiveDisabled: boolean;
  archiveIcon: string;
  archiveText: string;
  onArchiveConfirm: () => Promise<void>;
}

class ArchiveProjectLink extends Component<ArchiveProjectLinkProps> {

  constructor(props: ArchiveProjectLinkProps) {
    super(props);
  }

  public render() {
    return (
      // This obviously isn't a side-panel-link, but the class styles it like we want
      <ModalLink
        classNames="col-12 action-menu-item side-panel-link font-weight-normal"
        disabled={this.props.archiveDisabled}
        content={{
          body: `${this.props.archiveText} this project?`,
          cancelButtonText: "Cancel",
          confirmButtonAction: this.props.onArchiveConfirm,
          confirmButtonText: this.props.archiveText,
          confirmButtonType: this.props.archiveText === "Archive" ? "primary-danger" : "primary",
          title: this.props.archiveText,
        }}
        testId="archive-project-modal-link"
      >
        <i className={`${this.props.archiveIcon} pr-1`} />{this.props.archiveText}
      </ModalLink>
    );
  }
}

export { ArchiveProjectLink };
